import React from 'react';
import PropTypes from 'prop-types';

import styles from './IconListItem.module.scss';

const IconListItem = ({ icon, label, subtext } = {}) => (
	<li className={styles.item}>
		<span className={styles.icon}>{icon}</span>
		<span className={styles.content}>
			{label}
			{subtext && <span className={styles.subtext}>{subtext}</span>}
		</span>
	</li>
);

const iconListItem = {
	icon: PropTypes.node.isRequired,
	label: PropTypes.string.isRequired,
	subtext: PropTypes.string,
};

IconListItem.defaultProps = {
	subtext: undefined,
};

IconListItem.propTypes = iconListItem;

export default IconListItem;
